module.exports = __webpack_public_path__ + "static/img/content_1.3754599.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/5/content_1.jpg
// module id = /0OI
// module chunks = 27